import { createSlice } from '@reduxjs/toolkit';
import { HttpMethod } from '../../../Asset/httpMethod';
import { startLoader, stopLoader } from './loaderSlice';
import { AlertPopup } from '../../../Asset/common';

const initialState = {
  loading: false,
};

export const registerUserOld = (userData) => async (dispatch) => {
  dispatch(startLoader());
  try {
    debugger
    const res = await HttpMethod.Register('/Authorization/Account/RegisterWithUsrDocs', userData);

    // console.log('Registration response:', res);
    if (res && res?.status === 200) {
      // Handle success
      if (AlertPopup && AlertPopup.SuccessPopup) {
        AlertPopup.SuccessPopup('Registration successful!');
      }
      dispatch(stopLoader());
    }
  } catch (error) {
    // Handle error
    console.error('Error registering user:', error);
    if (AlertPopup && AlertPopup.ErrorPopup) {
      AlertPopup.ErrorPopup('An error occurred while registering. Please try again later.');
    }
    dispatch(stopLoader());
  }
};

export const registerUser = (userData) => async (dispatch) => {
  dispatch(startLoader());
  try {
    const res = await HttpMethod.Register('/Authorization/Account/RegisterWithUsrDocs', userData);

    if (res && res?.status === 200) {
      if (AlertPopup && AlertPopup.SuccessPopup) {
        AlertPopup.SuccessPopup('Registration successful!');
      }
      dispatch(stopLoader());
      return true;
    }

    const errorMsg =
      typeof res?.data === "string"
        ? res.data
        : res?.data?.message || "An error occurred while registering. Please try again later.";

    if (AlertPopup && AlertPopup.ErrorPopup) {
      AlertPopup.ErrorPopup(errorMsg);
    }
    dispatch(stopLoader());
    return false;
  } catch (error) {
    console.error('Error registering user:', error);
    if (AlertPopup && AlertPopup.ErrorPopup) {
      AlertPopup.ErrorPopup('An error occurred while registering. Please try again later.');
    }
    dispatch(stopLoader());
    return false;
  }
};

export const registrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    // You can add additional reducers if needed
  },
});

export const { /* Any additional reducers */ } = registrationSlice.actions;

export default registrationSlice.reducer;